import React, { FC } from 'react'
import t from '../../../../../translations/main'

import Icon from 'src/components/Core/Iconography/Icon/Icon'
import Font from 'src/components/Core/Typography/Font/Font'
import {
  FileNameAndInput,
  FileNameStyle,
  InputAndButtonSection,
  InputStyle,
  SendButtonWrapper,
  TextInputWrapper
} from '../GeneralMessage.styles'
import Flex from 'src/components/Layout/Flex/Flex'
import Input from 'src/components/Atoms/Input/Input'
import { SendCommentType } from './types'

const SendComment: FC<SendCommentType> = props => {
  const {
    setFileData,
    fileData,
    setEmptyMessageError,
    sendComment
  } = props
  return (
    <InputAndButtonSection>
      <TextInputWrapper justifyContent='flex-start'>
        <InputStyle
          type='file'
          name={'name'}
          id='fileInput'
          onChange={event => {
            const files: FileList = (event?.target as HTMLInputElement)?.files
            setFileData({ name: files?.[0]?.name || '', data: files?.[0]})
          }}
        />
        <Icon
          name='attachment'
          size='s'
          color='ultraViolet'
          clickFunction={() => (document.querySelector('#fileInput') as HTMLInputElement)?.click()}
        />
        <FileNameAndInput flexDirection='column' alignItems='flex-start' maxWidth>
          {
            fileData.data &&
              <FileNameStyle>
                <Flex as='label' htmlFor='fileInput'>
                  {fileData.name}
                </Flex>
                <Icon name='close' color='error' clickFunction={() => {
                  (document.getElementById('fileInput') as HTMLInputElement).value = null
                  setFileData({name: '', data: null})
                }}/>
              </FileNameStyle>
          }
          <Input
            isTextarea
            name='input-text-send-area'
            minHeight='0'
            marginBottom='0'
            paddingLeft='0'
            inputStyleMargin='0'
            inputStyleBoxSizing='border-box'
          />
        </FileNameAndInput>
      </TextInputWrapper>
      <SendButtonWrapper
        justifyContent='space-evenly'
        alignItems='flex-start'
        onClick={() => {
          const comment = document.querySelector('textarea').value
          if(comment === '') {
            setEmptyMessageError(true)
            return
          }
          sendComment(comment)
        }}
      >
        <Font color='blank'>{t('onboarding.generalMessage.send')}</Font>
        <Icon
          name='arrowSendRightUp'
          size='s'
          color='blank'
        />
      </SendButtonWrapper>
    </InputAndButtonSection>
  )
}

export default SendComment
